.container {
    display: inline-block;
    position: relative;
    z-index: 10;
}

.container:before,
.container .initials,
.container img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

.container img {
    z-index: 10;
}

.container:hover {
    border: 2px solid rgba(255, 255, 255, 0.2); /* Same as navbar button hover states */
    margin: -2px;
}

.indicator-base {
    z-index: 10;
    position: absolute;
    right: -2px;
    width: 25%;
    height: 25%;
    border-radius: 50%;
    border: 2px solid var(--sidebar-primary);
}

.online-indicator {
    composes: indicator-base;
    top: 0;
    background-color: var(--success);
}

.offline-indicator {
    composes: indicator-base;
    top: 0;
    background-color: var(--grey-lt);
}

.status-indicator {
    z-index: 11;
    position: absolute;
    right: -2px;
    bottom: -2px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: var(--sidebar-primary);
    padding: 2px;
}

.initials {
    background-color: #fff;
    font-weight: 500;
    color: var(--sidebar-primary);
    cursor: default; /* no text bar */
    text-align: center;
    text-transform: uppercase;
}

.container-active {
    composes: container;
}

.container-active .initials {
    background-color: var(--sidebar-primary) !important;
    color: #fff !important;
}

.has-border {
    border: 2px solid var(--focus-blue);
    margin: -2px;
}
